import { APIResult } from '../wishList/APIResult';
import { webRequest } from '../client/HttpClient';
import { logAPIErrorToNewrelic } from '../wishList/utils';

interface SkuNotificationDetail {
    id: string;
    customerNotifiableEvents?: CustomerNotifiableEvents;
}

interface ProductQuickViewResponse {
    emailMeWhenBackInStock: boolean;
    skus?: SkuNotificationDetail[];
}
interface ProductNotificationDetailsResponse {
    skuId: string;
    productId: string;
    emailMeWhenBackInStock: boolean;
    customerNotifiableEvents?: CustomerNotifiableEvents;
}

export const getProductNotificationDetails = async (
    productId: string,
    skuId: string,
    allowedToFail = true,
): Promise<APIResult<ProductNotificationDetailsResponse>> => {
    const url = `${process.env.REACT_APP_QUICKVIEW_URL}/${productId}`;

    const response = await webRequest(url, {}, allowedToFail);
    const apiResult = new APIResult<ProductNotificationDetailsResponse>();
    apiResult.showError = false;
    if (!response) {
        logAPIErrorToNewrelic(`getProductNotificationDetails`, `No response`, {
            response: response,
            result: apiResult,
            errorMessage: apiResult.errorMessage,
            showError: apiResult.showError,
            url: url,
            productId: productId,
            allowedToFail: allowedToFail,
        });
        return apiResult;
    }

    if (response.ok) {
        apiResult.success = true;
        const data = (await response.json()) as ProductQuickViewResponse;
        const skuNotificationDetail = data.skus?.find((s) => s.id === skuId);
        apiResult.data = {
            skuId: skuId,
            productId: productId,
            customerNotifiableEvents: skuNotificationDetail?.customerNotifiableEvents,
            emailMeWhenBackInStock: data.emailMeWhenBackInStock,
        };
    } else {
        logAPIErrorToNewrelic(`getProductNotificationDetails`, `Response Not OK`, {
            ...response,
            result: apiResult,
            errorMessage: apiResult.errorMessage,
            showError: apiResult.showError,
            url: url,
            productId: productId,
            allowedToFail: allowedToFail,
        });
    }
    return apiResult;
};
